<mat-checkbox [class]="customClass" [indeterminate]="isIndeterminate()" [checked]="isChecked()" (click)="$event.stopPropagation()"
    (change)="toggleSelection($event)">
    {{text}}
</mat-checkbox>